import { cx } from '@/utils/cx';
import styles from '@/styles/components/WeekdayPicker/style.scss';

/** Monday first, as the club's week reads. Values are Date#getDay: 0 = Sunday … 6 = Saturday. */
const DAYS = [
  { value: 1, short: 'Mon', name: 'Monday' },
  { value: 2, short: 'Tue', name: 'Tuesday' },
  { value: 3, short: 'Wed', name: 'Wednesday' },
  { value: 4, short: 'Thu', name: 'Thursday' },
  { value: 5, short: 'Fri', name: 'Friday' },
  { value: 6, short: 'Sat', name: 'Saturday' },
  { value: 0, short: 'Sun', name: 'Sunday' },
];

interface WeekdayPickerProps {
  legend: string;
  /** The days that are on (Date#getDay numbers), in any order. */
  value: number[];
  /** Called with the days that are on, sorted. */
  onChange: (days: number[]) => void;
  hint?: string;
}

/** Seven toggle chips, Mon to Sun; any set of days can be on. */
export function WeekdayPicker({ legend, value, onChange, hint }: WeekdayPickerProps) {
  const toggle = (day: number) =>
    onChange((value.includes(day) ? value.filter((d) => d !== day) : [...value, day]).sort((a, b) => a - b));
  return (
    <fieldset className={styles.fieldset}>
      <legend className={styles.legend}>{legend}</legend>
      <div className={styles.days}>
        {DAYS.map((d) => {
          const on = value.includes(d.value);
          return (
            <label key={d.value} className={cx(styles.day, on && styles.on)} title={d.name}>
              <input type="checkbox" className={styles.input} checked={on} aria-label={d.name} onChange={() => toggle(d.value)} />
              {d.short}
            </label>
          );
        })}
      </div>
      {hint && <p className={styles.hint}>{hint}</p>}
    </fieldset>
  );
}
